import {
  CreateAttractionRequestBody,
  CreateRestaurantBarRequestBody,
} from 'src/tripPlanner/utils/itemConversions/common'
import { ExploreItem } from 'tripPlanner/types/common'

export interface Params {
  exploreItem: ExploreItem
  templateId?: string
  templateItemId?: string
  type:
    | CreateAttractionRequestBody['type']
    | CreateRestaurantBarRequestBody['type']
  isInItinerary?: boolean
  startDate?: string
}

export function createExploreItemBookmarkPayload({
  exploreItem,
  templateId,
  templateItemId,
  type,
  isInItinerary = false,
  startDate,
}: Params): CreateAttractionRequestBody | CreateRestaurantBarRequestBody {
  return {
    type,
    place: {
      type: 'GEO',
      name: exploreItem.name,
      address: exploreItem.place.address,
      photoUrl: exploreItem.photo?.photoUri,
      id: exploreItem.place.id,
      region: exploreItem.place.region,
      point: {
        lat: exploreItem.place.point.lat,
        lng: exploreItem.place.point.lng,
      },
    },
    phone: exploreItem.phone,
    sourceType: 'Explore',
    status: 'PLANNED',
    url: exploreItem.website,
    code: exploreItem.place.id,
    isBooked: false,
    templateId,
    templateItemId,
    isInItinerary,
    startDate,
  }
}
